import { isWindowDefined } from "../element/isWindowDefined";

/**
 * Thin, SSR-safe, read-and-remove-only wrapper around `localStorage`.
 *
 * `localStorage` persists indefinitely and across tabs, so it is a strictly
 * larger at-rest footprint than `sessionStorage` for sensitive values. It is
 * retained here only to read and clear *legacy* payloads that predate the move
 * to `sessionStorage`, so those values can be migrated forward and removed from
 * long-lived storage (SMA-2668 / SMA-3172). It intentionally exposes no `set`
 * method — writing sensitive data back into long-lived storage is exactly what
 * the migration is undoing.
 *
 * All accesses are guarded: `localStorage` can throw (private-mode quota,
 * disabled storage) and is undefined during SSR.
 */
export const localStore = {
  get(key: string): string | null {
    if (!isWindowDefined()) {
      return null;
    }
    try {
      return window.localStorage.getItem(key);
    } catch {
      return null;
    }
  },

  remove(key: string): void {
    if (!isWindowDefined()) {
      return;
    }
    try {
      window.localStorage.removeItem(key);
    } catch {
      // Ignore.
    }
  },
};
